
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#204ECF","fill-rule":"evenodd","d":"M42 25.917L22.778 45.208l8.805 8.875L25.713 60 0 34l19.14-19.25-8.723-8.792L16.37 0 42 25.917zM17.486 38.625c.166-.042.33-.125.62-.458l10.914-11c.33-.292.413-.459.454-.625a1.195 1.195 0 0 0 0-.542c-.04-.167-.165-.333-.454-.625l-3.473-3.5c-.29-.333-.454-.417-.62-.458a1.167 1.167 0 0 0-.537 0c-.166.041-.33.166-.62.458l-10.914 11c-.33.292-.413.458-.454.625a1.195 1.195 0 0 0 0 .542c.04.166.165.333.454.625l3.473 3.5c.29.333.454.416.62.458.207.042.372.042.537 0zM31.293 5.417c0-1.5.496-2.75 1.571-3.834C33.898.542 35.18 0 36.626 0c1.488 0 2.77.542 3.803 1.583C41.463 2.625 42 3.917 42 5.417s-.537 2.75-1.57 3.791c-1.034 1.042-2.316 1.584-3.804 1.584s-2.728-.5-3.762-1.584c-1.033-1.041-1.57-2.291-1.57-3.791zm.91 0c0 1.25.413 2.333 1.281 3.208.868.875 1.902 1.333 3.183 1.333 1.24 0 2.315-.458 3.142-1.333a4.423 4.423 0 0 0 1.323-3.208c0-1.292-.455-2.334-1.323-3.209-.868-.875-1.902-1.333-3.142-1.333s-2.315.458-3.141 1.333c-.869.875-1.323 1.917-1.323 3.209zm5.704 2.958l-1.446-2.583h-.951v2.583h-.868V2.458h2.397c1.2 0 1.86.709 1.86 1.667 0 .833-.62 1.458-1.446 1.625L38.9 8.375h-.993zM35.51 3.25v1.792h1.364c.744 0 1.157-.292 1.157-.875 0-.625-.372-.917-1.157-.917H35.51z"}})])
          )
        }
      }
    